import axiosInstance from './axiosInstance';

const BASE = (pid) => `/plants/${pid}/users`;

export const getUsers = async (pid, params) => {
  return await axiosInstance.get(BASE(pid), { params });
};

export const getUserByLogin = async (pid, loginId) => {
  return await axiosInstance.get(`${BASE(pid)}/${loginId}`);
};

export const createUser = async (pid, data) => {
  return await axiosInstance.post(BASE(pid), data);
};

export const updateUser = async (pid, loginId, data) => {
  return await axiosInstance.put(`${BASE(pid)}/${loginId}`, data);
};

export const deleteUser = async (pid, loginId) => {
  return await axiosInstance.delete(`${BASE(pid)}/${loginId}`);
};

export const resetPassword = async (pid, loginId, newPassword) => {
  return await axiosInstance.post(`${BASE(pid)}/${loginId}/reset-password`, { newPassword });
};

// Frontend theme preference update
export const updateTheme = async (pid, loginId, color) => {
  return await axiosInstance.patch(`${BASE(pid)}/${loginId}/theme`, { color });
};

// Helper to get all modules for the checkbox list
export const getAllModules = async () => {
  return await axiosInstance.get('/modules');
};


// Add these to src/api/users.api.js

export const getRolesByUser = async (pid, loginId) => {
  return await axiosInstance.get(`/plants/${pid}/roles/user/${loginId}`);
};

export const assignRoles = async (pid, data) => {
  // data will be an array of role objects
  return await axiosInstance.post(`/plants/${pid}/roles`, data);
};